module.exports = __webpack_public_path__ + "static/media/13.228cc64e.svg";